import AttachmentsPreview from './AttachmentsPreview';

export default AttachmentsPreview;
